import React from 'react';
import { HUMANS } from '../data/populations';
import { COMPILED_LABEL } from '../data/sources';
import { useScenario } from '../contexts/ScenarioContext';
import { formatCompact, formatInt } from '../utils/format';
import { CounterPanel } from '../components/census/CounterPanel';
import { ScenarioSwitcher } from '../components/census/ScenarioSwitcher';
import { RatioGauge } from '../components/census/RatioGauge';
import { QuickStats } from '../components/census/QuickStats';
import { PopulationBreakdown } from '../components/census/PopulationBreakdown';
import { SourceRef } from '../components/SourceRef';
export function Census() {
  const {
    scenario
  } = useScenario();
  return <>
      <section className="border-b border-line" data-id="element-519" data-mp="2lfd7nvm00f4">
        <div className="mx-auto max-w-[1400px] px-5 pb-12 pt-10 md:px-8 md:pt-14" data-id="element-520" data-mp="2n0bnol1o3i9">
          <div className="flex flex-wrap items-end justify-between gap-x-10 gap-y-3" data-id="element-521" data-mp="327vvcl93xi2p">
            <h1 className="max-w-3xl font-serif text-[2rem] leading-[1.1] text-ink md:text-[2.75rem]" data-id="element-522" data-mp="368o65ixmnv13">
              A running count of the machine population, set against our own.
            </h1>
            <p className="font-mono text-[11.5px] text-muted" data-id="element-523" data-mp="2z13furl3pb3p">Compiled {COMPILED_LABEL} · extrapolated from dated bases</p>
          </div>

          <div className="mt-10 grid border-y border-line md:grid-cols-2 md:divide-x md:divide-line" data-id="element-524" data-mp="2u6pem8jrc9r4">
            <CounterPanel kind="human" title="Humans" subtitle="World population" base={HUMANS.base} baseTime={HUMANS.baseTime} ratePerSec={HUMANS.ratePerSec} sourceId={HUMANS.sourceId} rateLabel="+2.2 / sec" footnote={`base ${formatInt(HUMANS.base)}, Oct 2026`} data-id="element-525" data-mp="2p84o50ub54fv" />
            <div className="border-t border-line md:border-t-0" data-id="element-526" data-mp="9itablwsfsbp">
              <CounterPanel kind="machine" title="Machines" subtitle={scenario.short} base={scenario.count} baseTime={HUMANS.baseTime} ratePerSec={scenario.ratePerSec} sourceId={scenario.sourceIds[0]} rateLabel={<>
                    +{scenario.ratePerSec} / sec
                    <SourceRef id="fermi" estimate={{
                low: `${(scenario.ratePerSec / 2).toFixed(1)}/s`,
                high: `${scenario.ratePerSec * 2}/s`
              }} note="Assumed growth rate — our estimate." data-id="element-528" data-mp="1ozo8fmg3vbv0" />
                  </>} footnote={`range ${formatCompact(scenario.low)}–${formatCompact(scenario.high)}`} data-id="element-527" data-mp="9ib725bpkdua" />
            </div>
          </div>

          <div className="mt-8" data-id="element-529" data-mp="27rh11fr9iv27">
            <ScenarioSwitcher data-id="element-530" data-mp="27umpqtvzbuxe" />
          </div>
          <RatioGauge data-id="element-531" data-mp="2cqk44unomr7j" />
        </div>
      </section>
      <QuickStats data-id="element-532" data-mp="2ct6cuxmb7crc" />
      <PopulationBreakdown data-id="element-533" data-mp="wdd88cwevcyq" />
    </>;
}